export enum RacingEventStatusType {
    IsNotStarted = 0,
    IsRaceOff = 1,
    IsResult = 2,
    IsOver = 3
}